export default __webpack_public_path__ + "static/media/app_jio_saavan.7c9b384d.svg";